var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-fragment',[_c('DefaultHeader'),_c('fade-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('main',{staticClass:"main-container"},[_vm._t("default")],2)]),_c('DefaultFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }